<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="sf_code,sf_sccode,sf_custname"
      placeholder="输入单据编号、合同编号、客户进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/crm/serve_fee/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.sf_code}}</p>
          <p class="list-item-muted">{{item.sf_custname}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'yyyy-MM-dd'">{{item.sf_date}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.sf_status=='未审核'}"
          >{{item.sf_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
      <!-- <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('ms_total')}}</em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sale/servefee/list",
      filters: [
        {
          type: "date",
          name: "servefee.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: 'MAIN'
            },
            {
              value: 1,
              label: "待审核",
              mode: 'MAIN',
              condition: "sf_status='未审核'"
            },
            {
              value: 2,
              label: "已审核",
              mode: 'MAIN',
              condition: "sf_status='已审核'"
            }
          ]
        }
      ]
    };
  }
};
</script>